export default __webpack_public_path__ + "static/agency-user2-105d08a8850e5c48d3972772ae70c9b4.png";